// Tenantra Inc. - Careers: open positions
import { useEffect, useState } from 'react';
import api from '@/services/api';
import { getCurrentUser } from '@/services/auth';
import { CareersLayout } from './CareersLayout';

export default function CareersPage() {
  const [jobs, setJobs] = useState(null);
  const user = getCurrentUser();
  const isCandidate = user?.role === 'candidate';

  useEffect(() => {
    api.get('/careers/jobs').then(r => setJobs(r.data.jobs)).catch(() => setJobs([]));
  }, []);

  return (
    <CareersLayout right={
      <a href={isCandidate ? '/careers/portal' : '/careers/login'} className="text-slate-600 hover:text-slate-900" data-testid="careers-nav-portal">
        {isCandidate ? 'My applications' : 'Candidate sign in'}
      </a>
    }>
      <div className="max-w-3xl">
        <h1 className="font-archivo text-3xl sm:text-4xl font-bold text-slate-900 tracking-tight mb-3" data-testid="careers-heading">Careers at Tenantra</h1>
        <p className="text-sm sm:text-base text-slate-600 leading-relaxed mb-10">
          Tenantra is a Canadian rent-reporting and tenant-screening platform. We are a small team working directly with credit bureaus, payment providers, and landlords. All roles are remote.
        </p>

        <h2 className="text-xs font-semibold uppercase tracking-[0.14em] text-slate-500 mb-3">Open positions</h2>
        {jobs === null ? (
          <div className="h-20 border border-slate-200 animate-pulse bg-slate-50" />
        ) : jobs.length === 0 ? (
          <div className="border border-slate-200 px-5 py-8 text-sm text-slate-500" data-testid="careers-empty">
            There are no open positions at the moment.
          </div>
        ) : (
          <ul className="border border-slate-200 divide-y divide-slate-200" data-testid="careers-job-list">
            {jobs.map(job => (
              <li key={job.id}>
                <a href={`/careers/${job.slug}`} className="flex items-center justify-between gap-4 px-5 py-4 hover:bg-slate-50 transition-colors" data-testid={`job-link-${job.slug}`}>
                  <div className="min-w-0">
                    <p className="text-sm font-semibold text-slate-900">{job.title}</p>
                    <p className="text-xs text-slate-500 mt-0.5">{job.location} · {job.employment_type}{job.compensation ? ` · ${job.compensation}` : ''}</p>
                  </div>
                  <span className="text-xs font-medium text-teal-700 flex-shrink-0">View</span>
                </a>
              </li>
            ))}
          </ul>
        )}
      </div>
    </CareersLayout>
  );
}
